import ZJApp from '../../../../app'

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
    service: 'BaseDataService',
    controller: 'Grouppolling'
};

const methods = [
    'AddPollingGroup',
    'DelPollingGroup',
    'UpdatePollingGroup',
    'GetGroupPagingList'
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const SwiperListApi = ZJApi.defineNewApi('SwiperListApi', factory);

export default SwiperListApi;